// src/protocols/hyperlane/labels.ts
var HYPERLANE = {
  protocolId: "hyperlane",
  displayName: "Hyperlane",
  docs: "https://docs.hyperlane.xyz"
};
var HYPERLANE_COMPONENTS = {
  /** Value component for the canonical `message_id` kind — a Hyperlane Explorer
   * deep link for a `messageId` hash. */
  messageId: "HyperlaneMessageId"
};
var HYPERLANE_MESSAGE_ID_KIND = "message_id";
var HYPERLANE_FIELD_LABELS = {
  messageId: "Message ID",
  messageNonce: "Message nonce",
  sourceChain: "Source chain",
  destChain: "Destination chain"
};

export { HYPERLANE, HYPERLANE_COMPONENTS, HYPERLANE_FIELD_LABELS, HYPERLANE_MESSAGE_ID_KIND };
//# sourceMappingURL=chunk-KGJDYYPB.js.map
//# sourceMappingURL=chunk-KGJDYYPB.js.map